/**
 * @fileoverview GET handler for the "/apps/transformations/:transformation_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { RootCacheKey } from "../types";
import { appsTransformationsTransformationId } from "./constants";
import type { GetTransformationPayload } from "./types";

type GetTransformationDetailArgs = [transformationId: string] | [transformationId: string, operatorSafe: boolean];

export const getTransformationDetail = reactQueryFetcherAdapter<
  typeof appsTransformationsTransformationId,
  readonly [
    rootKey: RootCacheKey<typeof appsTransformationsTransformationId>,
    ...originalKey: GetTransformationDetailArgs,
  ],
  GetTransformationDetailArgs,
  GetTransformationPayload
>(
  appsTransformationsTransformationId,
  (
    signal: AbortSignal,
    ...[transformationId, operatorSafe]: GetTransformationDetailArgs
  ): Promise<GetTransformationPayload> => {
    return fetch(
      `/apps/transformations/${transformationId}`,
      "GET",
      { operator_safe: operatorSafe },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
